export const en = {
    confirming: `Confirming your account...`,
    status: `Confirmation status`,
    waiting: `Please wait while we confirm your account...`,
    error: `Account confirmation failed. Please try again or contact support.`,
};
//# sourceMappingURL=en.js.map